import { render, staticRenderFns } from "./LoaderGray.vue?vue&type=template&id=34223c7b&scoped=true"
import script from "./LoaderGray.vue?vue&type=script&lang=js"
export * from "./LoaderGray.vue?vue&type=script&lang=js"
import style0 from "./LoaderGray.vue?vue&type=style&index=0&id=34223c7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34223c7b",
  null
  
)

export default component.exports